<div class="custom-modal-content" style="height: 100%;">
  <div class="custom-modal-header" style="height: 10%;">
    <div style="display: flex; flex-direction: row; ">
    <button type="submit" class="custom-button custom-submit-button" (click)="sendEmail()"><i class="fa-solid fa-paper-plane"></i></button>
    <select style="width: 300px;" (change)="onAccountSelected($event.target.value)">
      <option *ngFor="let account of accounts" [value]="account">
        {{ account }}
      </option>
    </select>

    <div style="margin-top: 10px; display: flex;">
      <!-- Si no se está agregando una nueva categoría, mostramos el select -->
      <ng-container>
        <select style="width: 300px;" (change)="onCategoryChange($event.target.value)">
          <option value="" disabled selected>Selecciona una categoría</option>
          <option *ngFor="let category of categories" [value]="category">
            {{ category }}
          </option>
          <option value="new">Nuevo +</option>
        </select>
      </ng-container>
      <!-- Si se seleccionó "Nuevo +", se muestra un input para escribir la nueva categoría -->
      <ng-container *ngIf="isAddingNewCategory">
        <input type="text" [(ngModel)]="newCategory" placeholder="Ingrese nueva categoría"
          style="width: 300px;" (blur)="onNewCategoryBlur()" />
      </ng-container>
      <!-- <button (click)="selectExistent()">Existent</button> -->

      <button (click)="saveEmail()">Save</button>

      <label>Guardar como Campaña</label>
      <input type="checkbox" [(ngModel)]="checkbox">
  <div *ngIf="checkbox">
      <input
      type="text"
      [formControl]="cityCtrl"
      list="loc-list"
      (input)="onInput()"
      placeholder="Escribe la ubicacion…"
      autocomplete="off"
      style="width:100%; padding:0.5em; box-sizing:border-box;"
    >

    <datalist id="loc-list">
      <option *ngFor="let s of suggestions" [value]="s.label"></option>
    </datalist>

    <!-- Opcional: mostrar selección -->
  </div>
  <div *ngIf="checkbox" style="font-family: Arial, sans-serif;">
        <!-- Input de búsqueda -->
        <input
          name="searchText"
          type="text"
          [(ngModel)]="searchSubcatCampaign"
          (input)="filterSubcatsCampaign()"
          autocomplete="off"
          placeholder="Buscar subcategoría..."
          style="width: 100%; padding: 8px; font-size: 16px; box-sizing: border-box;"
        />
        <!-- Lista de sugerencias -->
        <ul *ngIf="filteredSubcatsCampaign.length > 0" style="list-style: none; padding: 0; margin: 0; background-color: white; z-index: 99; border: 1px solid #ccc; max-height: 200px; overflow-y: auto; position: absolute;">
          <li
            *ngFor="let subcat of filteredSubcatsCampaign"
            (click)="selectSubcatCampaign(subcat)"
            style="padding: 8px; cursor: pointer; border-bottom: 1px solid #eee;"
          >
            {{ subcat.name }}
          </li>
        </ul>
  </div>
  <div *ngIf="checkbox">
    <input type="text" style="width: 100%; padding: 8px; font-size: 16px; box-sizing: border-box;" [(ngModel)]="sector" placeholder="Sector">
  </div>
<!-- <div style="background-color: green;">
<button>Save Campaign</button>
</div> -->
    </div>

  </div>
    <button type="button" class="custom-close-button" (click)="onClose()">✖</button>
  </div>
  <div class="custom-modal-body" style="height: 90%; display: flex; flex-direction: row;">
    <div style="height: 100%; width: 30%; overflow-y: auto; padding: 5px; border-right: 1px solid #ccc;">
      <div *ngFor="let category of categories" style="margin-bottom: 15px;">
        <h5 style="margin: 0 0 5px 0; font-size: 14px;">{{ category }}</h5>
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li *ngFor="let email of mailsGrouped[category]" style="margin-bottom: 3px;
          padding: 12px;
          font-size: 16px;
          background: #e7e7e7;
          border-radius: 12px;
          border: 1px solid #d0d0d0;
          cursor: pointer;" (click)="importMail(email)">
            {{ email.title }}
          </li>
        </ul>
      </div>
    </div>


    <form style="height: 100%; width: 90%;">

      <div class="custom-form-group" style="display: flex; flex-direction: row; height: 7%;">

        <input
          style="width: 20%;"
          type="text"
          id="uniqueEmailSubject"
          class="custom-input"
          [(ngModel)]="email.subject"
          name="uniqueSubject"
          placeholder="Asunto"
          required
        />
        <input
        type="email"
        id="uniqueEmailRecipient"
        class="custom-input"
        [(ngModel)]="email.recipient"
        (ngModelChange)="validateEmails($event)"
        name="uniqueRecipient"
        placeholder="Para: (separados por comas para múltiples)"
        required
      />
      <p *ngIf="invalidEmails.length > 0" class="error-message">
        Los siguientes correos son inválidos: {{ invalidEmails.join(', ') }}
      </p>

      </div>

      <div style="max-width: 600px; margin: 20px auto; font-family: Arial, sans-serif;">
        <!-- Input de búsqueda -->
        <input
          name="searchText"
          type="text"
          [(ngModel)]="searchText"
          (input)="filterSubcats()"
          placeholder="Buscar subcategoría..."
          style="width: 100%; padding: 8px; font-size: 16px; box-sizing: border-box;"
        />
        <!-- Lista de sugerencias -->
        <ul *ngIf="filteredSubcats.length > 0" style="list-style: none; padding: 0; margin: 0; border: 1px solid #ccc; max-height: 200px; overflow-y: auto;">
          <li
            *ngFor="let subcat of filteredSubcats"
            (click)="selectSubcat(subcat)"
            style="padding: 8px; cursor: pointer; border-bottom: 1px solid #eee;"
          >
            {{ subcat.name }}
          </li>
        </ul>

        <!-- Código generado -->
        <div *ngIf="generatedCode" style="margin-top: 20px;">
          <h3 style="font-size: 18px;">Código generado (se copió al portapapeles):</h3>
          <!-- <textarea
            style="width: 100%; height: 300px; padding: 10px; box-sizing: border-box; font-family: monospace;"
            readonly
          >{{ generatedCode }}</textarea> -->
          <p *ngIf="copySuccess" style="color: green;">¡Código copiado al portapapeles!</p>
        </div>
      </div>
      <!-- Editor Ngx -->
      <div class="custom-form-group" id="emailEditorContainer" style="height: 93%;">
        <label for="uniqueEmailContent">Contenido del correo</label>
        <email-editor
          #emailEditor
          [options]="options"
          (loaded)="editorLoaded($event)"
          (ready)="editorReady($event)"
          style="height: 100%;"
        ></email-editor>
      </div>

      <!-- Footer -->

    </form>


  </div>
</div>
